import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AppPermission } from '@app/shared/services/apps/apps.service';

@Component({
  standalone: false,
  selector: 'sbnb-hostkit',
  template: `
    <sbnb-apps-detail-page
      vendorCode="hostkit"
      name="Hostkit"
      logoTile="/assets/images/apps/hostkit.png"
      builtBy="Hostkit"
      builtByLink="https://hostkit.pt/?sc=Hospitable"
      [categories]="['Accounting']"
      [helpLink]="{ href: 'https://hostkit.pt/suporte/', text: 'Hostkit help desk' }"
      [permissions]="[AppPermission.propertyRead, AppPermission.enrichmentRead, AppPermission.enrichmentSmartLockCode]"
      [helpArticles]="[
        {
          id: '9260294',
          title: 'Connecting Hospitable with Hostkit'
        }
      ]">
      <sbnb-image-carousel [images]="['/assets/images/apps/hostkit/1.webp']"></sbnb-image-carousel>
      <ng-container description>
        <p>
          Automate all your legal and fiscal obligations in Portugal. Certified invoicing, immigration bulletins (SEF),
          city tax, INE and more.
        </p>

        <ul class="list list__looser">
          <li>
            Invoicing: Automatic issuing and submission of invoices for your reservations and commissions to the AT.
          </li>
          <li>
            SEF Bulletins: Automatic collection and submission of all required data of your guests to the SEF (SIBA).
          </li>
          <li>Modelo 30: Automatic reverse-charge tax form for all commissions of EU based booking channels.</li>
          <li>City Tax: Automatic city tax processing and invoicing, with option to charge guests with markup.</li>
          <li>INE and COPE: Automatic submission of INE's IPHH report and emission of COPE from Bank of Portugal.</li>
        </ul>
      </ng-container>
    </sbnb-apps-detail-page>
  `,
  styleUrls: ['./hostkit.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HostkitComponent {
  AppPermission = AppPermission;
}
